<template>
  <v-card>
    <v-card-title>{{ $t('settings.notifications.title') }}</v-card-title>
    <v-card-text>
      <v-switch class="mt-0" data-testid="enable-notifications-toggle"
        v-model="enabled">
        <template v-slot:prepend>
          <v-icon color="green" v-if="enabled">mdi-bell-ring</v-icon>
          <v-icon color="red" v-else>mdi-bell-off</v-icon>
        </template>
        <template v-slot:append>
          <cp-help i18n="notifications.enable"/>
        </template>
      </v-switch>
      <v-slider
        v-model="timeout"
        :disabled="!enabled"
        :step="1"
        max="10"
        min="1"
        ticks
        thumb-label
        data-testid="timeout-notifications-slider"
      >
        <template v-slot:prepend>
          <v-icon>mdi-timer</v-icon>
        </template>
        <template v-slot:append>
          <span class="mt-1 mr-2">{{ timeout }}s</span>
          <cp-help i18n="notifications.timeout"/>
        </template>
      </v-slider>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { NotifyPermissions } from 'Store/notify'

export default {
  name: 'settings-notifications',
  computed: {
    ...mapGetters({
      getNotifications: 'settings/notifications'
    }),
    enabled: {
      get: function () {
        return this.getNotifications.enabled
      },
      set: function (enabled) {
        const params = {
          enabled: enabled,
          timeout: this.getNotifications.timeout
        }
        this.setNotifications(params)
        if (enabled) {
          NotifyPermissions()
        }
      }
    },
    timeout: {
      get: function () {
        const data = this.getNotifications
        return data.timeout / 1000
      },
      set: function (timeout) {
        const params = {
          enabled: this.getNotifications.enabled,
          timeout: timeout * 1000
        }
        this.setNotifications(params)
      }
    }
  },
  methods: {
    ...mapActions({
      setNotifications: 'settings/setNotifications'
    })
  }
}
</script>

<style>
</style>
